module.exports = __webpack_public_path__ + "static/media/SPEDIDAM-LOGO-RVB_Positif.1973e8bb.svg";